// umlaut-check: skip — Datenschluessel ("wochenbedarf", "sicherheitsbestand"
// usw.) sind technische Bezeichner aus BestellrechnerAnalysator (oskar_werte).

import React from "react";
import {Card, Table} from "react-bootstrap";
import HeaderWithHelp from "../SalesAnalysis/HeaderWithHelp.jsx";
import {formatDatum, formatMenge} from "./format.js";

function tageBisHeute(datumIso) {
    if (!datumIso) {
        return null;
    }
    const ziel = new Date(datumIso + "T00:00:00");
    const heute = new Date();
    heute.setHours(0, 0, 0, 0);
    return Math.round((ziel.getTime() - heute.getTime()) / 86400000);
}

/**
 * Oskars Bestellrechner bleibt der Vergleichsmaßstab, nicht die Vorlage
 * (PLAN.md Abschnitt 4a-Einleitung, UMSETZUNG.md "oskar_werte" ist reiner
 * Vergleichsmaßstab) - erscheint nur, wenn eine Zeile aus seiner Excel
 * übernommen wurde.
 */
export default function ArtikelOskarVergleich({oskarWerte, prognose}) {
    if (!oskarWerte) {
        return null;
    }

    const erwartet = prognose?.status === "gerechnet" ? prognose.szenarien.erwartet : null;
    const unserWochenbedarf = prognose?.status === "gerechnet" ? prognose.wochenbedarf_basis?.wert : null;
    const unserSicherheitsbestand = prognose?.status === "gerechnet" ? prognose.mindestbestand?.wert : null;
    const unsereBestellmenge = erwartet?.bestellmenge?.wert ?? null;
    const unsereReichweiteTage = erwartet?.reichweite_tage?.wert ?? null;
    const oskarReichweiteTage = tageBisHeute(oskarWerte.reichweite_datum);

    return (
        <Card className="shadow-sm mb-3">
            <Card.Header className="fw-semibold">
                <HeaderWithHelp help="Oskars linearer Bestellrechner (Excel), unverändert mitgeführt – Vergleichsmaßstab, nicht Vorlage für unsere Rechnung.">
                    Oskars Werte im Vergleich
                </HeaderWithHelp>
                {oskarWerte.stand && <span className="small text-muted ms-2">Stand {formatDatum(oskarWerte.stand)}</span>}
            </Card.Header>
            <Card.Body>
                <Table size="sm" borderless className="mb-2">
                    <thead>
                        <tr className="small text-muted">
                            <th></th>
                            <th>
                                <HeaderWithHelp help="Wert aus Oskars Excel-Bestellrechner.">Oskar</HeaderWithHelp>
                            </th>
                            <th>
                                <HeaderWithHelp help="Wert aus der Cosmos-Prognose dieses Bereichs.">Unser Rechenkern</HeaderWithHelp>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="small">Wochenbedarf</td>
                            <td>{formatMenge(oskarWerte.wochenbedarf)}</td>
                            <td>{formatMenge(unserWochenbedarf)}</td>
                        </tr>
                        <tr>
                            <td className="small">Sicherheitsbestand</td>
                            <td>{formatMenge(oskarWerte.sicherheitsbestand)}</td>
                            <td>{formatMenge(unserSicherheitsbestand)}</td>
                        </tr>
                        <tr>
                            <td className="small">Bestellmenge</td>
                            <td>{formatMenge(oskarWerte.bestellmenge_4_wochen)}</td>
                            <td>{formatMenge(unsereBestellmenge)}</td>
                        </tr>
                        <tr>
                            <td className="small">Reichweite (Tage)</td>
                            <td>{oskarReichweiteTage !== null ? formatMenge(oskarReichweiteTage) : "–"}</td>
                            <td>{formatMenge(unsereReichweiteTage)}</td>
                        </tr>
                    </tbody>
                </Table>
                <p className="small text-muted mb-0">
                    Die Werte weichen ab, weil Oskar linear mit einem pauschalen Aufschlag statt mit gemessenem
                    Verbrauch rechnet, die offene Menge („offen, nicht reserviert“) nicht berücksichtigt und keine Saisonfaktoren je
                    Farbton kennt.
                </p>
            </Card.Body>
        </Card>
    );
}
